<template>    
    <div class="card class" :class="{ 'mb': mb }">
        <div class="card-body">
            <a href="javascript: void(0);" @click="$bvModal.show('classModal-' + virtuosoClass.id)">
                <img class="card-img-top-virtuoso" :src="virtuosoClass.imageUris ? virtuosoClass.imageUris.cardThumb.url : ''" :alt="virtuosoClass.name" loading="lazy">
            </a>

            <h3 v-if="lessonNum" class="grey-subtitle">Lesson {{ lessonNum }}</h3>
            
            <a href="javascript: void(0);"  @click="$bvModal.show('classModal-' + virtuosoClass.id)"><h2 class="card-title">{{ virtuosoClass.name }}</h2></a>
            <p class="card-text">{{ virtuosoClass.description_short }}</p>
            <p class="card-text">
                <strong>
                    Class length: {{ virtuosoClass.duration }}
                </strong>
            </p>
            <div class="btn-area">
                <a @click="$bvModal.show('classModal-' + virtuosoClass.id)" class="btn btn-primary btn-main">Read more</a>
            </div>
        </div>

        <b-modal modal-class="class-modal" :id="'classModal-' + virtuosoClass.id" size="xl" :hide-header="true" :ok-only="true" ok-variant="link" ok-title="Close">

            <h1 class="class-modal-header">{{ virtuosoClass.name }}</h1>

            <div class="body">
                <div class="row justify-content-center">
                    <div class="col-md-10">

                        <hr>

                        <div class="alert text-center alert-info mb-3" v-if="virtuosoClass.hasEnded">
                            This class ended at <strong>{{ virtuosoClass.endedAt }}</strong>. 
                            <template v-if="!virtuosoClass.isUserEnrolledInCourse">
                                If you had enrolled on this course you would have been able to watch a highlights 
                                video of this class.
                            </template>
                            <template v-else>
                                <template v-if="virtuosoClass.youtubeEmbedRecordedClass != null">
                                    You can watch the recording of the session below.
                                </template>
                                <template v-else>
                                    A recording of the session will be uploaded here for you to re-watch.
                                </template>
                            </template>
                        </div>

                        <div class="text-center meta-info-modal">
                            Duration: {{ virtuosoClass.duration }}
                        </div>

                        <div class="mb-3" v-if="virtuosoClass.hasEnded && virtuosoClass.youtubeEmbedRecordedClass != null && virtuosoClass.isUserEnrolledInCourse">
                            <!-- Past classes -->
                            <span v-html="virtuosoClass.youtubeEmbedRecordedClass"></span>
                        </div>

                        <!-- Top text area, descript left, equipment and materials right -->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="description">
                                    <h2>About the Lesson</h2>
                                    <span v-html="virtuosoClass.descriptionLongHTML"></span>
                                </div>
                            </div>
                            <div class="col-md-6">                        
                                <div class="equipment" v-if="
                                    typeof virtuosoClass.equipment !== 'undefined' &&
                                    !(
                                        virtuosoClass.hasEnded && virtuosoClass.youtubeEmbedRecordedClass != null
                                    )
                                ">
                                    <h2>Equipment Needed</h2>
                                    <span v-html="virtuosoClass.equipmentHTML"></span>
                                </div>
                                <div class="equipment material" v-if="typeof virtuosoClass.materials !== 'undefined' && virtuosoClass.isUserEnrolledInCourse">
                                    <h2>Class Material</h2>
                                    <p>
                                        We recommend you download and view the following material before starting
                                        this class.
                                    </p>
                                    <ul>
                                        <li v-for="material in virtuosoClass.materials" :key="material.id">
                                            <a :href="material.url" target="_blank">{{ material.label }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="video mt-3" v-if="virtuosoClass.youtubeEmbed != null && virtuosoClass.youtubeEmbedRecordedClass == null">
                            <h2>Watch the video</h2>
                            <span v-html="virtuosoClass.youtubeEmbed"></span>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>    
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                default: null
            },
            classData: {
                type: Object,
                default: null
            },
            mb: {
                type: Boolean,
                default: false
            },
            lessonNum: {
                type: Number,
            },
        },

        data() {
            return {
                virtuosoClass: {},
            }
        },

        mounted() {
            if(this.classData) {
                this.virtuosoClass = this.classData;
            } else {
                this.getClass();
            }
        },

        computed: {
            // Replace \n with <br>. nl2br
            /* Replaced for markdown
            longDescription: function() {
                if(this.virtuosoClass.description_long) {
                    return this.virtuosoClass.description_long.replace(/(?:\r\n|\r|\n)/g, '<br>');
                } else {
                    return '';
                }
            },
            */

            // Vue complains if we just access imageUris directly
            topBanner: function () {
                return this.virtuosoClass.imageUris ? this.virtuosoClass.imageUris.topBanner.url : '';
            }
        },

        methods: {
            getClass: function() {
                axios.get('/api/classes/' + this.id)
                    .then((response) => {
                        this.virtuosoClass = response.data;
                    });
            }
        }
    }
</script>
